<template>
  <div class="landing-page-success">
    <div class="message-card card-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76">
        <g fill="none" fill-rule="evenodd">
          <path d="M-10-10h96v96h-96z"/>
          <path fill="#292929" d="M38 4C19.222 4 4 19.222 4 38c0 18.777 15.222 34 34 34 18.777 0 34-15.223 34-34C72 19.222 56.777 4 38 4m0 72C17.013 76 0 58.987 0 38S17.013 0 38 0s38 17.013 38 38-17.013 38-38 38"/>
          <path fill="#292929" d="M13 39.36a2.001 2.001 0 0 1-.83-3.82 16.745 16.745 0 0 0 8.34-8.36 2 2 0 1 1 3.64 1.65 20.745 20.745 0 0 1-10.32 10.35 2 2 0 0 1-.83.18M63.35 39.35a1.997 1.997 0 0 1-.82-.18 20.751 20.751 0 0 1-10.36-10.34 2 2 0 0 1 3.64-1.65 16.76 16.76 0 0 0 8.36 8.35 2 2 0 0 1-.83 3.82h.01zM25 52a9 9 0 0 1-9-9 2 2 0 0 1 4 0 5 5 0 0 0 10 0 2 2 0 0 1 4 0 9 9 0 0 1-9 9M51 52a9 9 0 0 1-9-9 2 2 0 0 1 4 0 5 5 0 1 0 10 0 2 2 0 0 1 4 0 9 9 0 0 1-9 9"/>
          <path stroke="#292929" stroke-linecap="round" stroke-width="3" d="M28 62h20"/>
        </g>
      </svg>
      <span>{{$t('step5.failed.title')}}</span>
    </div>

    <div class="landing-page">
      <router-link :to="{name: 'step4'}" tag="a" class="submit">
        {{$t('step5.failed.btn')}}
      </router-link>
    </div>
  </div>
</template>

<script>
    export default {
        name: "payment-failed"
    }
</script>



// WEBPACK FOOTER //
// src/pages/tunnel/step5/payment-failed.vue